"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaPoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const CommandCode_1 = require("../../CommandCode");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
class MetaPoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.dispatcher = {
            [chain_1.ParachainId.ASTAR]: '0xf3780EBbF5C0055c0951EC1c2Abc1b3D77713459',
        };
        this.executor = {
            [chain_1.ParachainId.MOONBEAM]: '0xf6626F6a906DCA97C816c06DD32FFEC40761de34',
        };
    }
    getStartPoint() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'MetaPoolCode: Unseted chainId');
        return this.dispatcher[Number(chainId)];
    }
    getProtocolExecutor() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'AlgebraPoolCode: Unseted chainId');
        return this.executor[Number(chainId)];
    }
    getProtocolExecutorStartPoint() {
        return this.getProtocolExecutor();
    }
    getSwapCodeForRouteProcessor(leg, _route, to) {
        const tokenFromIndex = leg.tokenFrom.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const tokenToIndex = leg.tokenTo.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const poolData = (0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, uint8, uint8, address, address'), [
            leg.poolAddress,
            tokenFromIndex,
            tokenToIndex,
            leg.tokenFrom.address,
            leg.tokenTo.address,
        ]);
        const code = new HEXer_1.HEXer()
            .uint8(CommandCode_1.CommandCode.SWAP_ZENLINK_STABLE_POOL)
            .bool(true) // isMetaSwap
            .address(to)
            .bytes(poolData)
            .toString();
        return code;
    }
    getSwapCodeForRouteProcessor2(leg, _route, to) {
        const tokenFromIndex = leg.tokenFrom.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const tokenToIndex = leg.tokenTo.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const poolData = (0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, uint8, uint8, address'), [
            leg.poolAddress,
            tokenFromIndex,
            tokenToIndex,
            leg.tokenTo.address,
        ]);
        const code = new HEXer_1.HEXer()
            .uint8(3) // stableswap pool
            .bool(true) // isMetaSwap
            .address(to)
            .bytes(poolData)
            .toString();
        return code;
    }
    getSwapCodeForAggregationRouter(leg, _route, to) {
        const tokenFromIndex = leg.tokenFrom.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const tokenToIndex = leg.tokenTo.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const poolData = (0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, uint8, uint8, address'), [
            leg.poolAddress,
            tokenFromIndex,
            tokenToIndex,
            leg.tokenTo.address,
        ]);
        const code = new HEXer_1.HEXer()
            .address(this.getProtocolExecutor())
            .bytes((0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('uint8, address, bytes'), [
            1, // isMetaSwap
            to,
            poolData,
        ]))
            .toString();
        return code;
    }
}
exports.MetaPoolCode = MetaPoolCode;
